export default {
  order: 7,
  layerGroupId: 'GROUP_LC',
  dataLayer: {
    id: 'TREE_COVER_HEIGHT',
    order: 7,
    type: 'remoteDataLayer',
    uuid: '2a83effa-f8be-425b-9766-502e65525861',
    groupId: 'GROUP_LC',
  },
  layer: {
    metadata: {
      metadata: null,
      legendConfig: {
        name: {
          en: 'Tree cover height',
          fr: 'Hauteur du couvert végétal',
          es: 'Altura de la cubierta arbórea',
          pt: 'Altura da cobertura das árvores',
          id: 'Tinggi tutupan pohon',
          zh: '树木覆盖高度',
          ka: 'Tree cover height',
        },
        type: 'gradient',
        items: [
          {
            name: {
              zh: '3m',
              pt: '3m',
              ka: '3m',
              id: '3m',
              fr: '3m',
              es: '3m',
              en: '3m',
            },
            color: '#bbffb8',
          },
          {
            name: {
              zh: '30m',
              pt: '30m',
              ka: '30m',
              id: '30m',
              fr: '30m',
              es: '30m',
              en: '30m',
            },
            color: '#045200',
          },
        ],
      },
      interactionConfig: {},
    },
    id: 'TREE_COVER_HEIGHT',
    type: 'tree-cover-height',
    url: 'https://storage.googleapis.com/gfw-data-layers/umd-tree-height/{z}/{x}/{y}.png',
    technicalName: 'tree_cover_height',
    label: {
      en: 'Tree cover height',
      es: 'Altura de la cubierta arbórea',
      fr: 'Hauteur du couvert végétal',
      id: 'Tinggi tutupan pohon',
      ka: 'Tree cover height',
      pt: 'Altura da cobertura das árvores',
      zh: '树木覆盖高度',
    },
    sublabel: {
      en: '2019, 30m, global, UMD/NASA GEDI',
      es: '2019, 30m, global, UMD/NASA GEDI',
      fr: '2019, 30m, mondial, UMD/NASA GEDI',
      id: '2019, 30m, global, UMD/NASA GEDI',
      ka: '2019, 30m, global, UMD/NASA GEDI',
      pt: '2019, 30m, global, UMD/NASA GEDI',
      zh: '2019年, 30米, 全球, UMD/NASA GEDI',
    },
  },
  isMetadataError: false,
  isError: false,
};
